export const composeEn = {
  open: "Write an email",
  title: "New email",
  to: "To",
  cc: "Cc",
  subject: "Subject",
  template: "Template",
  no_template: "No template",
  body: "Message",
  attachments: "Attachments",
  add_attachment: "Attach a file",
  // GAVION batch 3 (B3-T14): remaining size, guards and template confirmation
  attachments_remaining: "%{size} remaining",
  attachment_blocked: "File type not allowed: %{name}",
  attachment_read_failed: "Could not read %{name}.",
  fix_invalid: "Fix the invalid addresses before sending.",
  replace_title: "Replace the subject and message?",
  replace_body: "The template replaces the text already typed.",
  attachments_limit: "10 MB total",
  // GAVION template attachments
  template_files_loading: "Adding the template's attachments…",
  template_files_failed:
    "The template's attachments could not be added. Pick it again or attach them by hand.",
  template_files_too_large:
    "The template's attachments exceed the limit with yours (10 MB, 10 files): they were not added.",
  remove_attachment: "Remove %{name}",
  remove_recipient: "Remove %{email}",
  add_recipient: "Add",
  send: "Send",
  sending: "Sending…",
  cancel: "Cancel",
  sent: "Email sent.",
  invalid_email: "Invalid address: %{email}",
  required_to: "Add at least one recipient.",
  required_subject: "Add a subject.",
  placeholder_left: "Replace the [[…]] passages before sending.",
  not_connected: "Connect Microsoft 365 to send from your mailbox.",
  connect_link: "Open integrations",
  demo: {
    schedule: "Schedule a demo",
    reschedule: "Edit the demo",
    cancel: "Cancel the demo",
    title_book: "Schedule an Outlook demo",
    title_reschedule: "Edit the demo",
    start: "Date and time",
    duration: "Duration",
    minutes: "%{n} min",
    attendee: "Attendee email (optional)",
    confirm: "Create the Outlook invitation",
    save: "Save",
    comment: "Message to attendees (optional)",
    booked: "Demo scheduled in Outlook.",
    moved: "Demo moved.",
    cancelled: "Demo cancelled in Outlook.",
    outlook_hint: "A Teams meeting is added automatically.",
    attendee_suppressed:
      "Cannot invite: this attendee unsubscribed or asked not to be contacted.",
    reconnect_needed:
      "Reconnect Microsoft 365 to change or cancel this Outlook demo.",
    reconnect_hint: "Reconnect Microsoft 365",
    status_loading: "Loading Microsoft 365 status…",
    shifted:
      "That time does not exist (clocks change): the demo is set to %{time}.",
    not_connected: "Connect Microsoft 365 to create the Outlook invitation.",
  },
  message: {
    open: "Open message",
    title: "Message",
    loading: "Loading message…",
    failed: "Could not display this message.",
    attachments: "Attachments",
    download: "Download %{name}",
    inbound: "Email received",
    outbound: "Email sent",
    demo_body: "Message content (demo).",
    reply: "Reply",
    // GAVION open-pixel
    opened: "Opened once |||| Opened %{smart_count} times",
    opened_last:
      "Opened once — last: %{at} |||| Opened %{smart_count} times — last: %{at}",
    auto_open: "probably an automatic open",
  },
};
